<template>
	<div>
		<label class="topcoat-switch"
		       :class="{'is-danger': errors.has(checkboxName) }">
			<input type="checkbox"
			       :name="checkboxName"
			       v-validate="expression"
			       class="topcoat-switch__input">
			<div class="topcoat-switch__toggle"></div>
		</label>
		<span v-show="errors.has(checkboxName)"
		      class="help is-danger"
		>X</span>
	</div>
</template>

<script>
	export default {
//		name:"checkbox",
		data() {
			return {
				checkboxName:'',
				expression: {
					rules: {
						required: true,
					}
				}
			}
		},
		created() {
			this.checkboxName = 'checkbox' + this._uid
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	label.is-danger {
		border-color: #ff3860;
	}
	.topcoat-switch__toggle:before, .topcoat-switch__toggle:after {
		content: '';
	}
</style>



// WEBPACK FOOTER //
// Switcher.vue?25fb79cc